import UsLogo from '../assets/images/united-states-flag-icon.svg'
import GermanLogo from '../assets/images/flag.png';
import AlbanischLogo from '../assets/images/albanisch.jpeg';
import KroatischLogo from '../assets/images/kroatisch.png';
import TurkeyLogo from '../assets/images/turkey.png';
import enCountries from './../utils/countries/en.json';
import germanCountries from './../utils/countries/de.json'
import { Business, MailOutline, PersonOutline, PhoneIphone } from '@mui/icons-material';

export const baseURL = process.env.REACT_APP_BASE_URI;

export const SignUpInputData = [
        { name: 'firstName', label: 'Vorname*', icon: <PersonOutline />, placeholder: 'Max', translationKey: 'common_label_first_name' },
        { name: 'lastName', label: 'Nachname*', icon: <PersonOutline />, placeholder: 'Mustermann', translationKey: 'common_label_last_name' },
        { name: 'companyName', label: 'Firmenname*', icon: <Business />, placeholder: 'Muster GmbH', translationKey: 'common_label_company_name' },
        { name: 'email', label: 'E-Mail*', icon: <MailOutline />, placeholder: 'max@beispiel.de',  translationKey: 'common_label_email'},
        { name: 'mobileNumber', label: 'Handynummer*', icon: <PhoneIphone />, placeholder: '0151 12345678', translationKey: 'common_label_mobile_number' },
    ];

export const UserProfileData = {

    Generally: [
        { label: "First Name", type: "text", name: "firstName", translationKey: 'common_label_first_name', placeholderTranslationKey: 'common_placeholder_first_name' },
        { label: "Last Name", type: "text", name: "lastName", translationKey: 'common_label_last_name', placeholderTranslationKey: 'common_placeholder_last_name' },
        { label: "Phone Number", type: "number", name: "mobileNumber", translationKey: 'company_phone_number', placeholderTranslationKey: 'company_placeholder_phone_number' },
        { label: "Email", type: "text", name: "email", translationKey: 'common_label_email', placeholderTranslationKey: 'common_placeholder_email' },
        {
            label: "Language", type: "select", options: [
                { label: "English", value: "en" },
                { label: "German", value: "de" },
            ],
            name: "language",
            translationKey: 'profile_language',
            placeholderTranslationKey: 'profile_placeholder_language'
        }, ,
    ],

    "Change_Password": [
        { label: "Currant Password", type: "password", name: "password", translationKey: 'profile_currunt_password', placeholderTranslationKey: 'profile_placeholder_currant_password' },
        { label: "New Password", type: "password", name: "newPassword", translationKey: 'profile_new_password', placeholderTranslationKey: 'profile_placeholder_new_password' },
        { label: "Re-enter Password", type: "password", name: "confirmPassword", translationKey: 'profile_re-enter_password', placeholderTranslationKey: 'profile_placeholder_re-enter_password' },
    ],
}

export const StammdatenData = [
    {
        label: "Branche", name: "branche", type: "select", options: [
            { label: "Agrarwirtschaft", value: "agrarwirtschaft", translationKey: 'stammdaten_branche_menu_agrarwirtschaft' },
            { label: "Baugewerbe", value: "baugewerbe", translationKey: 'stammdaten_branche_menu_baugewerbe' },
            { label: "Chemie- und Rohstoffindustrie", value: "chemie-und-rohstoffindustrie", translationKey: 'stammdaten_branche_menu_chemie-und-rohstoffindustrie' },
            { label: "Handwerk", value: "handwerk", translationKey: 'stammdaten_branche_menu_handwerk' },
            { label: "E-Commerce", value: "e-commerce", translationKey: 'stammdaten_branche_menu_e-commerce' },
            { label: "Energie und Umwelt", value: "energie-und-umwelt", translationKey: 'stammdaten_branche_menu_energie-und-umwelt' },
            { label: "Finanzen, Versicherungen und Immobilien", value: "finanzen-versicherungen-und-immobilien", translationKey: 'stammdaten_branche_menu_finanzen-versicherungen-und-immobilien' },
            { label: "Freizeit", value: "freizeit", translationKey: 'stammdaten_branche_menu_freizeit' },
            { label: "Gesellschaft", value: "gesellschaft", translationKey: 'stammdaten_branche_menu_gesellschaft' },
            { label: "Handel", value: "handel", translationKey: 'stammdaten_branche_menu_handel' },
            { label: "Internet", value: "internet", translationKey: 'stammdaten_branche_menu_internet' },
            { label: "Konsumgüter", value: "konsumgueter", translationKey: 'stammdaten_branche_menu_konsumgueter' },
            { label: "Medien", value: "medien", translationKey: 'stammdaten_branche_menu_medien' },
            { label: "Metall und Elektronik", value: "metall-und-elektronik", translationKey: 'stammdaten_branche_menu_metall-und-elektronik' },
            { label: "Pharmaindustrie und Gesundheit", value: "pharmaindustrie-und-gesundheit", translationKey: 'stammdaten_branche_menu_pharmaindustrie-und-gesundheit' },
            { label: "Sport und Fitness", value: "sport-und-fitness", translationKey: 'stammdaten_branche_menu_sport-und-fitness' },
            { label: "Telekommunikation und IT", value: "telekommunikation-und-it", translationKey: 'stammdaten_branche_menu_telekommunikation-und-it' },
            { label: "Tourismus und Gastronomie", value: "tourismus-und-gastronomie", translationKey: 'stammdaten_branche_menu_tourismus-und-gastronomie' },
            { label: "Verkehr und Logistik", value: "verkehr-und-logistik", translationKey: 'stammdaten_branche_menu_verkehr-und-logistik' },
            { label: "Werbung und Marketing", value: "werbung-und-marketing", translationKey: 'stammdaten_branche_menu_werbung-und-marketing' },
            { label: "Wirtschaft und Politik", value: "wirtschaft-und-politik", translationKey: 'stammdaten_branche_menu_wirtschaft-und-politik' },
            { label: "Sonstige Branche", value: "sonstige-branche", translationKey: 'stammdaten_branche_menu_sonstige-branche' }
        ],
        translationKey: 'stammdaten_branche',
        placeholderTranslationKey: 'stammdaten_placeholder_branche'
    },

    {
        label: "Mitarbeiterzahl", name: "mitarbeiterzahl", type: "select", options: [
            { label: "1-3", value: "1-3" },
            { label: "4-10", value: "4-10" },
            { label: "11-50", value: "11-50" },
            { label: "50+", value: "50+" },
        ],
        translationKey: 'stammdaten_mitarbeiterzahl',
        placeholderTranslationKey: 'stammdaten_placeholder_mitarbeiterzahl'
    },
    { label: "Gründungjahr", type: "date", name: "grundungjahr", translationKey: 'stammdaten_gründungjahr', placeholderTranslationKey: 'stammdaten_placeholder_dd_mm_yyyy' },
];


export const CompanyProfileData = {
    Generally: [
        { label: "Name", type: "text", name: "name", translationKey: 'company_name', placeholderTranslationKey: 'company_placeholder_name' },
        {
            label: "Legal Form", name: "legal_Form", type: "select", options: [{ label: "GmbH", value: "gmbH" },
            { label: "GmbH & Co. KG", value: "gmbH & Co. KG" },
            { label: "UG", value: "UG" },
            { label : "AG", value: "AG"},
            { label: "E.K.", value: "E.K." },
            { label: "OHG", value: "OHG" },
            { label: "Einzelunternehmen", value: "Einzelunternehmen" },
            { label: "GbR", value: "GbR" },
            ], name: "legalForm",
            translationKey: 'company_legal_form',
            placeholderTranslationKey: 'company_placeholder_legal_form'
        },
        { label: "Email", type: "text", name: "email", translationKey: 'common_label_email', placeholderTranslationKey: "common_placeholder_email" },
        { label: "Website", type: "text", name: "website", translationKey: 'company_website', placeholderTranslationKey: 'company_placeholder_website' },
        { label: "Fax Number", type: "text", name: "faxNumber", translationKey: 'company_fax_number', placeholderTranslationKey: 'company_placeholder_fax_number' },
        { label: "Phone Number", type: "number", name: "mobileNumber", translationKey: 'company_phone_number', placeholderTranslationKey: 'company_placeholder_phone_number' },
        {
            label: "Country", type: "select", options: [{ label: "Germany", value: "germany" },

            ],
            name: "country",
            translationKey: 'company_country',
            placeholderTranslationKey: 'company_placeholder_country'
        },
        { label: "amtgericht", type: "text", name: "amtgericht", translationKey: 'company_amtgericht', placeholderTranslationKey: 'company_placeholder_amtgericht' },
    ],

    Generally_tax: [
        { label: "Tax Number", type: "text", name: "taxNumber", translationKey: 'company_tax_number', placeholderTranslationKey: 'company_placeholder_text_number' },
        { label: "VAT Identification Number", type: "text", name: "vatIdentificationNumber", translationKey: 'company_vat_Identification_number', placeholderTranslationKey: 'company_placeholder_vat_identification_number' },
    ],

    "Address": [
        { label: "Street", type: "text", name: "streetNo", translationKey: 'company_street', placeholderTranslationKey: 'company_placeholder_street' },
        { label: "Pincode", type: "number", name: "pincode", translationKey: 'company_pincode', placeholderTranslationKey: 'company_placeholder_pincode' },
        { label: "City", type: "text", name: "city", translationKey: 'company_city', placeholderTranslationKey: 'company_placeholder_city' },
    ],

    "Bank_Information": [
        { label: "Bank", type: "text", name: "bank", translationKey: 'company_bank', placeholderTranslationKey: 'company_placeholder_bank' },
        { label: "IBAN", type: "text", name: "iban", translationKey: 'company_iban', placeholderTranslationKey: 'company_placeholder_iban' },
        { label: "BIC", type: "text", name: "bic", translationKey: 'company_bic', placeholderTranslationKey: 'company_placeholder_bic' },
    ]

}

export const addUserData = [
    { label: "First Name", type: "text", name: "firstName", translationKey: 'common_label_first_name', placeholderTranslationKey: 'common_placeholder_first_name' },
    { label: "Last Name", type: "text", name: "lastName", translationKey: 'common_label_last_name', placeholderTranslationKey: 'common_placeholder_last_name' },
    { label: "Email", type: "text", name: "email", translationKey: 'common_label_email', placeholderTranslationKey: 'common_placeholder_email' },
    { label: "Mobile Number", type: "number", name: "mobileNumber", translationKey: 'common_label_mobile_number', placeholderTranslationKey: 'common_placeholder_mobile_number' },
];

export const addClientData = [
    { label: "First Name", type: "text", name: "firstName", translationKey: 'common_label_first_name', placeholderTranslationKey: 'common_placeholder_first_name' },
    { label: "Last Name", type: "text", name: "lastName", translationKey: 'common_label_last_name', placeholderTranslationKey: 'common_placeholder_last_name' },
    { label: "Company Name", type: "text", name: "company", translationKey: 'common_label_company_name', placeholderTranslationKey: 'common_placeholder_company_name' },
    { label: "Email", type: "text", name: "email", translationKey: 'common_label_email', placeholderTranslationKey: 'common_placeholder_email' },
    { label: "Mobile Number", type: "number", name: "mobileNumber", translationKey: 'common_label_mobile_number', placeholderTranslationKey: 'common_placeholder_mobile_number' },
];

export const SignInInputData = [
    { label: "Email", type: "text", name: "email", translationKey: 'common_label_email', placeholderTranslationKey: 'common_placeholder_email' },
    { label: "Password", type: "password", name: "password", translationKey: 'common_label_password', placeholderTranslationKey: 'common_placeholder_password' },
];

export const NewPasswordData = [
    { label: "New Password", type: "password", name: "password", translationKey: 'common_label_new_password', placeholderTranslationKey: 'profile_placeholder_new_password' },
    { label: "Confirme Password", type: "password", name: "confirm_password", translationKey: 'common_label_confirm_password', placeholderTranslationKey: 'common_placeholder_confirm_password' },
];

export const subscription = [
    { label: "bank_Name", text: "New Bank" },
    { label: "Reciver’s Name", text: "Finanz Controller GmbH" },
    { label: "IBAN", text: "DE23 5001 5001 5001 52" },
    { label: "BIC", text: "52JKIDN055" },
    { label: "Refrance Code", text: "998998" },
];

export const languageDetail = {
    label: "Language", type: "select", options: [
        { label: "Deutsch", value: "de", image: GermanLogo },
        { label: "English", value: "en", image: UsLogo },
        { label: "Albanisch", value: "sq", image: AlbanischLogo },
        { label: "Kroatisch", value: "hr", image: KroatischLogo },
        { label: "Türkisch", value: "tr", image: TurkeyLogo },
    ],
    name: "language"
}

export const StammdatenInputData = [
    {
        label: "Year", name: "year", type: "select", options: [
            { label: "2005", value: "2005" },
            { label: "2010", value: "2010" },
            { label: "2015", value: "2015" },
            { label: "2024", value: "2024" },
        ],
        translationKey: 'stammdaten_year',
        placeholderTranslationKey: 'stammdaten_placeholder_year'
    },

    { name: 'jahresabschluss', type: "text", label: 'Jahersabschuluss', translationKey: 'stammdaten_jahersabschuluss', placeholderTranslationKey: 'stammdaten_placeholder_jahersabschuluss' },
    { name: 'eigenkapital', type: "text", label: 'Eigenkapital', translationKey: 'stammdaten_eigenkapital', placeholderTranslationKey: 'stammdaten_placeholder_eigenkapital' },
    { name: 'fremdkapital', type: "text", label: 'Fremdkapital', translationKey: 'stammdaten_fremdkapital', placeholderTranslationKey: 'stammdaten_placeholder_fremdkapital' },
    { name: 'anlagevermögen', type: "text", label: 'Anlagevermögen', translationKey: 'stammdaten_anlagevermögen', placeholderTranslationKey: 'stammdaten_placeholder_anlagevermögen' },
    { name: 'still_reserven', type: "text", label: 'Still Reserven', translationKey: 'stammdaten_still_reserven', placeholderTranslationKey: 'stammdaten_placeholder_still_reserven' },
    { name: 'bilanzsumme', type: "text", label: 'Bilanzsumme', translationKey: 'stammdaten_bilanzsumme', placeholderTranslationKey: 'stammdaten_placeholder_bilanzsumme' },
];


export const StammdatenInhabarInputData = [
    {
        label: "Year", name: "year", type: "select", options: [
            { label: "2005", value: "2005" },
            { label: "2010", value: "2010" },
            { label: "2015", value: "2015" },
            { label: "2024", value: "2024" },
        ],
        translationKey: 'stammdaten_year',
        placeholderTranslationKey: 'stammdaten_placeholder_year'
    },

    { name: 'gewinn', type: "string", label: 'Gewinn', translationKey: 'stammdaten_gewinn', placeholderTranslationKey: 'stammdaten_placeholder_gewinn' },

];

export const statusColor = [{
    color: 'red',
    description: 'Plan has expired.'
},
{
    color: 'orange',
    description: 'Reminder before 7 days of plan expiry.'
},
{
    color: 'green',
    description: 'Plan is currently active.'
}]



export const kontencardColors = [
    "linear-gradient(270deg, #1A1A1A 0%, #1A1A1A 100%)",
    "linear-gradient(90deg, #E5D06F 0%, #B18330 100%)",
    "linear-gradient(180deg, #EBEBEB 0%, #B7B7B7 100%)",
    "linear-gradient(180deg, #EF7D82 0%, #92141A 100%)",
    "linear-gradient(270deg, #C18AFF 0%, #904DFF 100%)",
    "linear-gradient(270deg, #FF8AFF 0%, #FF4DFF 100%)",
];

export const kontenChartcolor = ["#1A1A1A", "#E5D06F", "#B7B7B7", "#92141A", "#904DFF", "#FF4DFF"];


export const addKontenData = [
    { label: "Bank name", type: "text", name: "bank_name", translationKey: 'bank_name', placeholderTranslationKey: 'enter_your_bank_name', handleKeyPress: false },
    { label: "IBAN", type: "text", name: "iban", translationKey: 'iban', placeholderTranslationKey: 'enter_your_iban', handleKeyPress: false },
    {
        label: "Currency", type: "select", name: "currency",
        options: [
            { label: "( $ ) United States Dollar", value: "$-United States Dollar" },
            { label: "( € ) Euro", value: "€-Euro" },
            { label: "( ₹ ) Indian Rupee", value: "₹-Indian Rupee" },
            { label: "( £ ) British Pound Sterling", value: "£-British Pound Sterling" },
            { label: "( ¥ ) Japanese Yen", value: "¥-Japanese Yen" },
            { label: "( CHF ) Swiss Franc", value: "CHF-Swiss Franc" },
            { label: "( A$ ) Australian Dollar", value: "A$-Australian Dollar" },
            { label: "( C$ ) Canadian Dollar", value: "C$-Canadian Dollar" },
            { label: "( R ) South African Rand", value: "R-South African Rand" },
            { label: "( ₽ ) Russian Ruble", value: "₽-Russian Ruble" },
            { label: "( R$ ) Brazilian Real", value: "R$-Brazilian Real" },
            { label: "( Mex$ ) Mexican Peso", value: "Mex$-Mexican Peso" },
            { label: "( S$ ) Singapore Dollar", value: "S$-Singapore Dollar" },
            { label: "( NZ$ ) New Zealand Dollar", value: "NZ$-New Zealand Dollar" },
            { label: "( ₩ ) South Korean Won", value: "₩-South Korean Won" },
            { label: "( HK$ ) Hong Kong Dollar", value: "HK$-Hong Kong Dollar" },
            { label: "( ﷼ ) Saudi Riyal", value: "﷼-Saudi Riyal" },
            { label: "( ₺ ) Turkish Lira", value: "₺-Turkish Lira" },
        ]
        , translationKey: 'Currency', placeholderTranslationKey: 'enter_your_currency'
    },
    { label: "Kontostand", type: "text", name: "kontostand", translationKey: 'Kontostand', placeholderTranslationKey: 'enter_your_kontostand', handleKeyPress: true },
];

export const addDarlehenData = [
    { label: "Bank name", type: "text", name: "bank_name", translationKey: 'bank_name', placeholderTranslationKey: 'enter_your_bank_name', handleKeyPress: false },
    { label: "IBAN", type: "text", name: "iban", translationKey: 'iban', placeholderTranslationKey: 'enter_your_iban', handleKeyPress: false },
    {
        label: "Currency", type: "select", name: "currency",
        options: [
            { label: "( $ ) United States Dollar", value: "$-United States Dollar" },
            { label: "( € ) Euro", value: "€-Euro" },
            { label: "( ₹ ) Indian Rupee", value: "₹-Indian Rupee" },
            { label: "( £ ) British Pound Sterling", value: "£-British Pound Sterling" },
            { label: "( ¥ ) Japanese Yen", value: "¥-Japanese Yen" },
            { label: "( CHF ) Swiss Franc", value: "CHF-Swiss Franc" },
            { label: "( A$ ) Australian Dollar", value: "A$-Australian Dollar" },
            { label: "( C$ ) Canadian Dollar", value: "C$-Canadian Dollar" },
            { label: "( R ) South African Rand", value: "R-South African Rand" },
            { label: "( ₽ ) Russian Ruble", value: "₽-Russian Ruble" },
            { label: "( R$ ) Brazilian Real", value: "R$-Brazilian Real" },
            { label: "( Mex$ ) Mexican Peso", value: "Mex$-Mexican Peso" },
            { label: "( S$ ) Singapore Dollar", value: "S$-Singapore Dollar" },
            { label: "( NZ$ ) New Zealand Dollar", value: "NZ$-New Zealand Dollar" },
            { label: "( ₩ ) South Korean Won", value: "₩-South Korean Won" },
            { label: "( HK$ ) Hong Kong Dollar", value: "HK$-Hong Kong Dollar" },
            { label: "( ﷼ ) Saudi Riyal", value: "﷼-Saudi Riyal" },
            { label: "( ₺ ) Turkish Lira", value: "₺-Turkish Lira" },
        ]
        , translationKey: 'Currency', placeholderTranslationKey: 'enter_your_currency'
    },
    { label: "Ursprungsbetrag", type: "text", name: "ursprungsbetrag", translationKey: 'module_ursprungsbetrag', placeholderTranslationKey: 'enter_your_ursprungsbetrag', handleKeyPress: true },
    { label: "Zahlungsbeginn", type: "date", name: "zahlungsbeginn", translationKey: 'zahlungsbeginn', placeholderTranslationKey: 'enter_your_zahlungsbeginn', handleKeyPress: false },
    { label: "Zahlungsende", type: "date", name: "zahlungsende", translationKey: 'zahlungsende', placeholderTranslationKey: 'enter_your_zahlungsende', handleKeyPress: false },
    { label: "Monatliche Rate", type: "text", name: "monatliche_rate", translationKey: 'monatliche_rate', placeholderTranslationKey: 'enter_your_monatliche_rate', handleKeyPress: true },
    { label: "Ausstehender Betrag", type: "text", name: "ausstehender_betrag", translationKey: 'darlehen_ausstehender_betrag', placeholderTranslationKey: 'enter_your_ausstehender_betrag', handleKeyPress: true },
    {
        label: "Zahlungsstatus", type: "select", name: "zahlung_status", translationKey: 'module_payment_status', placeholderTranslationKey: 'enter_your_zahlungsstatus',
        options: [
            { label: "Paid", value: "paid" },
            { label: "Unpaid", value: "unpaid" },
        ]

    }
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const countriesList = [
    {
        alpha: "en",
        list: enCountries
    },
    {
        alpha: "de",
        list: germanCountries
    }
]